"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Sample {
    constructor(data) {
        this.id = data.id;
        this.sample_code = data.sample_code;
        this.is_available = data.is_available;
        this.sent_back = data.sent_back;
        this.received_lab = data.received_lab;
    }
}
exports.default = Sample;
